<template>
  <van-popup class="apply" v-model="show" position="bottom" :close-on-click-overlay="false" :style="{height: '404px'}">
    <main class="apply-popup">
      <h3 class="title">申请证书</h3>
      <div class="tips">证书颁发后，证书信息将无法修改，请再次核实您的身份信息。</div>
      <div class="userinfo">
        <div class="userinfo-item">
          <span class="topic">姓名</span>
          <span class="result">{{ userInfo.name }}</span>
        </div>
        <div class="userinfo-item current">
          <span class="topic">机构</span>
          <span class="result">{{ userInfo.orgName }}</span>
        </div>
      </div>
      <div class="affirm">
        <van-checkbox v-model="checked" shape="square">确认以上信息无误</van-checkbox>
      </div>
      <div class="btn" @click="handleApply">申请证书</div>
      <div class="edit" @click="handleJumpUserInfo">信息有误，马上去修改</div>
    </main>
  </van-popup>
</template>

<script>
import {Toast} from 'vant'
export default {
  name: 'apply-popup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    show(newV) {
      if (!newV) {
        this.checked = false
      }
    }
  },
  methods: {
    handleApply() {
      if (!this.checked) {
        Toast.fail({
          message: '请确认信息无误',
          duration: 1500
        })
        return false
      }
      this.$emit('on-affirm')
    },
    handleJumpUserInfo() {
      this.$router.push('/customization/user-info')
    }
  }
}
</script>

<style lang="scss" scoped>
.apply {
  border-radius: 12px 12px 0 0;
}

.apply-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 17px;
  }
  .tips {
    margin-top: 16px;
    font-size: 15px;
    line-height: 23px;
    color: #f53f3f;
  }
  .userinfo {
    margin-top: 16px;
    width: 100%;
    padding: 16px 10px;
    box-sizing: border-box;
    background: #f8f8f8;
    border-radius: 6px;
    .userinfo-item {
      font-size: 15px;
      &.current {
        margin-top: 12px;
      }
      .topic {
        color: #808080;
      }
      .result {
        margin-left: 12px;
        color: #1a1a1a;
      }
    }
  }
  .affirm {
    margin-top: 20px;
    width: 100%;
  }
  .btn {
    margin-top: 20px;
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    color: #fff;
    background: linear-gradient(90deg, #4a86f6 0%, #4465f3 100%);
    border-radius: 25px;
  }
  .edit {
    margin-top: 16px;
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    color: #4465f3;
  }
}
</style>

<style lang="scss">
.affirm {
  .van-checkbox__icon {
    .van-icon {
      width: 18px;
      height: 18px;
      border-radius: 4px;
    }
  }
  .van-checkbox__label {
    font-size: 15px;
    color: #1a1a1a;
  }
}
</style>
